module.exports = __webpack_public_path__ + "img/horizontal_3_7_8023.80b19cca.png";